document.addEventListener('DOMContentLoaded', () => {
  let reviewsIoContainers = document.querySelectorAll('[data-reviews-io-carousel]');

  if (reviewsIoContainers.length < 1) return;

  const resetPosition = (container) => {
    container.style.setProperty('--reviews-carousel-left', `0px`);
    container.style.setProperty('--reviews-carousel-right', `0px`);

    if (window.innerWidth < 684) {
      container.classList.add('page-width');
      return;
    }

    container.classList.add('page-width');

    let child = container.querySelector('.shopify-block');

    let leftPos = child.getBoundingClientRect().x;
    let rightPos = child.getBoundingClientRect().right;

    container.style.setProperty('--reviews-carousel-left', `${leftPos}px`);
    container.style.setProperty('--reviews-carousel-right', `${rightPos}px`);

    container.classList.remove('page-width');
  };

  const resetAllReviewsCarousels = () => {
    reviewsIoContainers.forEach(resetPosition);
  };

  window.addEventListener('resize', resetAllReviewsCarousels);

  resetAllReviewsCarousels();
});
